<crm-budget-task-form
  *ngIf="(loading$ | async) === false"
  [task]="task"
  [canDelete]="(form$ | async)?.isEdit"
  [schemes]="schemes"
  [dealGroups]="dealGroups"
  [directions]="directions"
  [userGroups]="userGroups"
  [companies]="companies"
  [projects]="projects"
  (save)="saveTask($event)"
  (delete)="deleteTask()"
  [isModal]="true"></crm-budget-task-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
